var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4232 0.637051C24.6542 -0.18427 23.4118 -0.18427 22.6428 0.637051L13 10.9141L3.35722 0.615991C2.58817 -0.20533 1.34585 -0.20533 0.576792 0.615991C-0.192264 1.43731 -0.192264 2.76406 0.576792 3.58539L10.2196 13.8835L0.576792 24.1816C-0.192264 25.0029 -0.192264 26.3297 0.576792 27.151C1.34585 27.9723 2.58817 27.9723 3.35722 27.151L13 16.8529L22.6428 27.151C23.4118 27.9723 24.6542 27.9723 25.4232 27.151C26.1923 26.3297 26.1923 25.0029 25.4232 24.1816L15.7804 13.8835L25.4232 3.58539C26.1725 2.78512 26.1725 1.43731 25.4232 0.637051Z",
    fill: "#F9F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6adda67b960f778833c123a17507ca18.svg";
export { ForwardRef as ReactComponent };